// StorageService: abstracts storage for web (localStorage) and iOS (Capacitor Preferences).
// Capacitor Preferences persists across WKWebView data clears, unlike localStorage.
// Falls back to localStorage when Preferences plugin is not available.

let Preferences = null;
let preferencesReady = false;

try {
  const cap = require('@capacitor/preferences');
  Preferences = cap.Preferences;
  preferencesReady = true;
} catch {
  // @capacitor/preferences not installed — use localStorage fallback
}

export const StorageService = {
  get(key) {
    return localStorage.getItem(key);
  },

  set(key, value) {
    localStorage.setItem(key, value);
    if (preferencesReady) {
      Preferences.set({ key, value }).catch((e) => console.warn('Preferences.set failed:', e));
    }
  },

  remove(key) {
    localStorage.removeItem(key);
    if (preferencesReady) {
      Preferences.remove({ key }).catch((e) => console.warn('Preferences.remove failed:', e));
    }
  },

  // Restore keys from Capacitor Preferences into localStorage on app start.
  // Call this once at boot to recover tokens after WKWebView clears localStorage.
  async restore(keys) {
    if (!preferencesReady) return;
    for (const key of keys) {
      try {
        const { value } = await Preferences.get({ key });
        if (value !== null) {
          // Always prefer the Capacitor Preferences value since WKWebView
          // may clear localStorage but Preferences persists.
          localStorage.setItem(key, value);
        }
      } catch {
        // ignore
      }
    }
  },
};
